(function ($) {
	"use strict";

	Vegas.init();

	// WOW active
	new WOW().init();

	/**
	 * Listeners
	 * **/
	$(document).on('change', '.change_trigger_form', function () {
		let $self = $(this),
			$val = $self.find('option:selected').val(),
			formID = $self.data('form'),
			$form_trigger = $('.catalog-form-trigger[name=' + $self.attr('name') + ']');

		$form_trigger.find('option[value=' + $val + ']').attr('selected', true);

		$('#' + formID).trigger('submit');

		return false;
	});

	$(document).on('change', '.catalog-form-trigger', function () {
		$("#catalog-form-filter").submit();
	});

	$(document).on('click', '.form-ajax input', function () {
		let $self = $(this);

		$self.closest('.form-group').find('.form-text').removeClass('text-danger').text('');
		$self.removeClass('error');

		return false;
	});

	$(document).on('click', '.btn-get-nav', function () {
		let $self = $(this);

		if ($self.hasClass('is-active')) {
			$self.removeClass('is-active');
			vegasSidebar.close(this);
		} else {
			$self.addClass('is-active');
			vegasSidebar.open(this);
		}

		return false;
	});

	$(document).on('click', '.close-sidebar, .vg-sidebar', function (e) {
		if (e.target !== this) return;
		vegasSidebar.close(this);
		$('.btn-get-nav').removeClass('is-active');
		return false;
	});

	$(document).on('click', '.btn-get-filters', function () {
		vegasSidebar.open(this);
		return false;
	});
})(jQuery);
